import { hexToHsl, hslToHex, isValidHexColor } from "@tellescope/utils";

export interface EventCellColors {
  textColor: string;
  borderColor: string;
  backgroundColor: string;
}

export const FALLBACK_EVENT_COLOR_HEX = "#f9fafb";

const BACKGROUND_L = 0.96;
const BORDER_L = 0.88;
const TEXT_L = 0.26;
const TEXT_S_CAP = 0.75;

export const getEventCellColorsFromHex = (hex: string | null | undefined): EventCellColors => {
  const resolved = hex && isValidHexColor(hex) ? hex : FALLBACK_EVENT_COLOR_HEX;
  const hsl = hexToHsl(resolved)!;
  const saturation = hsl.s / 100;

  return {
    backgroundColor: hslToHex(hsl.h, saturation, BACKGROUND_L),
    borderColor: hslToHex(hsl.h, saturation, BORDER_L),
    textColor: hslToHex(hsl.h, Math.min(saturation, TEXT_S_CAP), TEXT_L),
  };
};
